/**
 * Marketing URL helper.
 *
 * The app subdomain (app.thedreamforgecompany.com) serves ONLY authenticated
 * app routes (/login, /register, /app/*, /portal/*, /embed/*, /forge-vision/r/:slug,
 * /public/investor-update). Anything else — including all legacy internal
 * marketing paths — must redirect to the Vercel-hosted marketing site.
 *
 * Deep-linking to specific marketing pages is intentionally DISABLED: the
 * Vercel site owns its own information architecture, and we don't want to
 * ship .html suffixes or dead paths from the app. Every call resolves to
 * the marketing root.
 */
export const MARKETING_BASE =
    (process.env.REACT_APP_MARKETING_DOMAIN || "https://thedreamforgecompany.com").replace(/\/+$/, "");

export function marketingUrl(/* path is intentionally ignored */) {
    return MARKETING_BASE + "/";
}
